import MainLayout from "../../../commons/layout/MainLayout/index";
import { useNavigate } from "react-router-dom";
import ROUTERS from "../../../commons/constans/router";
import HeaderHs2 from "../../../commons/components/Header/headerHs2";
import TabsComponent from "../../../commons/components/Tabs/TabsComponent";
import AllTab from "./allTab";
import AlbumTab from "./albumTab";
import SelfieTab from "./selfieTab";
import VideoTab from "./videoTab";
type Props = {
  footerShow: Boolean,
};
const AlbumComponent = ({ footerShow }: Props) => {
  const navigate = useNavigate();
  const handleLeftClick = () => {
    navigate(ROUTERS.HOME);
  };

  const albumData = [
    {
      src: "/images/album/img_album02@2x.png",
      title: "2021년 11월 12일",
    },
    {
      src: "/images/album/img_album02@2x.png",
      title: "2021년 11월 12일",
    },
    {
      src: "/images/album/img_album02@2x.png",
      title: "2021년 11월 12일",
    },
    {
      src: "/images/album/img_album02@2x.png",
      title: "2021년 11월 12일",
    },
    {
      src: "/images/album/img_album02@2x.png",
      title: "2021년 11월 12일",
    },
    {
      src: "/images/album/img_album02@2x.png",
      title: "2021년 11월 12일",
    },
  ];

  const videoData = [
    {
      src: "/images/album/video_image_box_album@2x.png",
      title: "2021년 11월 12일",
    },
    {
      src: "/images/album/video_image_box_album@2x.png",
      title: "2021년 11월 12일",
    },
    {
      src: "/images/album/video_image_box_album@2x.png",
      title: "2021년 11월 12일",
    },
  ];


  const allTab = (
    <>
      <AllTab 
        dataAlbum={albumData} 
        dataSelfie={albumData} 
        dataVideo={videoData}
        />
    </>
  );

  const albumTab = (
    <>
      <AlbumTab dataAlbum={albumData} />
    </>
  );

  const characterSelfieTab = (
    <>
      <SelfieTab dataAlbum={albumData} />
    </>
  );

  const videoTab = <>
    <VideoTab dataVideo={videoData} />
  </>;

  return (
    <MainLayout
      pageID={"album-page"}
      displayBottomNav={true}
      activeNav={"ALBUM"}
    >
      <HeaderHs2
        labelRight={false}
        labelLeft={true}
        title="앨범"
        handleLabelLeft={() => handleLeftClick()}
      />
      <div className="wrapper">
        <TabsComponent
          tabHeadings={["전체", "카드사진", "캐릭터셀카", "영상편지"]}
          tabContents={[allTab, albumTab, characterSelfieTab, videoTab]}
          activeIndex={0}
          // handleChangeTab={handleChangeTab}
        />
      </div>
    </MainLayout>
  );
};

export default AlbumComponent;
